// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/data/styles/index.scss
// module id = 1969
// module chunks = 13